export const DISPLAY_CLASSES = {
    inherit: ['[display:inherit]'],
    block: ['block'],
    'inline-block': ['inline-block'],
    inline: ['inline'],
    flex: ['flex'],
    'inline-flex': ['inline-flex'],
    table: ['table'],
    'inline-table': ['inline-table'],
    'table-caption': ['table-caption'],
    'table-cell': ['table-cell'],
    'table-column': ['table-column'],
    'table-column-group': ['table-column-group'],
    'table-footer-group': ['table-footer-group'],
    'table-header-group': ['table-header-group'],
    'table-row-group': ['table-row-group'],
    'table-row': ['table-row'],
    'flow-root': ['flow-root'],
    grid: ['grid'],
    'inline-grid': ['inline-grid'],
    contents: ['contents'],
    'list-item': ['list-item'],
    hidden: ['hidden'],
};
